import { Bootgrid } from "./bootgrid";

export function applyVisibleColumns(this: Bootgrid) {
    if (this.bootgridState.VisibleColumnIds?.length > 0) {
        resetVisibility.call(this);
        applyVisibility.call(this);
        orderByVisibility.call(this);
    }
}

export function orderByVisibility(this: Bootgrid) {
    const columnIdOrder = this.bootgridState.VisibleColumnIds;
    let lastMovedElement = null;

    columnIdOrder.forEach((columnId, orderIndex) => {
        this.$bootgrid.find("th").each((index, element) => {
            const currentColumnId = $(element).data("column-id");

            if (currentColumnId === columnId) {
                const $elementToMove = $(element).detach();

                if (lastMovedElement) {
                    $(lastMovedElement).after($elementToMove);
                } else {
                    this.$bootgrid.find("tr").prepend($elementToMove);
                }

                lastMovedElement = $elementToMove;
            }
        });
    });

    if (this.$bootgrid.find('th[data-column-id="commands"]').length > 0) {
        this.$bootgrid.find("tr").prepend(this.$bootgrid.find('th[data-column-id="commands"]'));
    }
}

export function applyVisibility(this: Bootgrid) {
    this.$bootgrid.find("th").each((index, element) => {
        if (this.bootgridState.VisibleColumnIds.includes($(element).data("column-id"))) {
            $(element).attr("data-visible", "true");
        }
    });
}

export function resetVisibility(this: Bootgrid) {
    this.$bootgrid.find("th").each((index, element) => {
        const $th = $(element);
        if (typeof $th.attr("data-visible") !== "undefined") {
            $th.attr("data-visible", "false");
        }
    });
}
